import {
    overwriteTimeZonesWarningTitle,
    overwriteTimeZonesWarningMessage,
} from './toggleShowTimeZones.locstring.json';
import { noButton } from 'owa-locstrings/lib/strings/nobutton.locstring.json';
import { yesButton } from 'owa-locstrings/lib/strings/yesbutton.locstring.json';
import loc, { format } from 'owa-localize';
import hasCustomTimeZones from 'owa-calendar-compose-form-store/lib/utils/hasCustomTimeZones';
import orchestrator from 'satcheljs/lib/orchestrator';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { getFullComposeViewState, getComposeEvent } from 'owa-calendar-compose-store-manager';
import { getUserTimeZone } from 'owa-session-store';
import {
    setShowDateSelectorTimeZones,
    toggleShowDateSelectorTimeZones,
} from 'owa-calendar-compose-form-actions';

orchestrator(toggleShowDateSelectorTimeZones, () => {
    const fullComposeViewState = getFullComposeViewState(null /* formId */);
    const { Start, End } = getComposeEvent(null /* formId */);

    if (hasCustomTimeZones(Start.tz, End.tz)) {
        confirm(
            loc(overwriteTimeZonesWarningTitle),
            format(loc(overwriteTimeZonesWarningMessage), getUserTimeZone()),
            false, //Resolve immediately
            { okText: loc(yesButton), cancelText: loc(noButton) }
        ).then(response => {
            if (response === DialogResponse.ok) {
                setShowDateSelectorTimeZones(!fullComposeViewState.showDateSelectorTimeZones);
            }
        });
    } else {
        setShowDateSelectorTimeZones(!fullComposeViewState.showDateSelectorTimeZones);
    }
});
